import api from '~/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getCategories(_, options) {
    return api.get('categories', options)
  },
  getCategory(_, id) {
    return api.get(`categories/${id}`)
  },
  createCategory(_, { form, options }) {
    return api.post('categories', form, options)
  },
  updateCategory(_, { options, form }) {
    return api.put(`categories/${form.id}`, form, options)
  },
  deleteCategory(_, id) {
    return api.delete(`categories/${id}`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
